import * as Yup from 'yup';
import { PaymentMethodDraft, PaymentMethodsFormFields } from '../../validationSchemas';
import { PaymentMethods } from './types';

const bankAccountValidationSchema = Yup.object({
    paymentMethod: Yup.string(),
    iban: Yup.string().required(),
    bic: Yup.string().required(),
    bankName: Yup.string().required(),
});

export const invoiceTemplateValidationSchema = Yup.object({
    standardTerms: Yup.string().max(999, 'Standard terms must not exceed 999 characters.').nullable(),
    paymentNotes: Yup.string().max(999, 'Payment notes must not exceed 999 characters.').nullable(),
    paymentLink: Yup.string().nullable(),
    bankAccount: Yup.array().of(bankAccountValidationSchema),
});

export const paymentMethodSchema: Yup.SchemaOf<PaymentMethodDraft> = Yup.object({
    paymentMethod: Yup.mixed<PaymentMethods>().nullable().required('Payment method is required'),
    url: Yup.string()
        .trim()
        .nullable()
        .when(PaymentMethodsFormFields.PAYMENT_METHOD, {
            is: PaymentMethods.PAY_PAL,
            then: (s) => s.required('URL is required').url('Please enter a valid URL'),
            otherwise: (s) => s.notRequired().nullable(),
        }),
    bankName: Yup.string()
        .nullable()
        .when(PaymentMethodsFormFields.PAYMENT_METHOD, {
            is: PaymentMethods.BANK_TRANSFER,
            then: (s) => s.required('Bank name is required'),
            otherwise: (s) => s.notRequired().nullable(),
        }),
    iban: Yup.string()
        .trim()
        .nullable()
        .when(PaymentMethodsFormFields.PAYMENT_METHOD, {
            is: PaymentMethods.BANK_TRANSFER,
            then: (s) =>
                s
                    .matches(/^[A-Z0-9 ]+$/i, { message: 'IBAN must be alphanumeric', excludeEmptyString: true })
                    .required('IBAN is required'),
            otherwise: (s) => s.notRequired().nullable(),
        }),
    bic: Yup.string()
        .trim()
        .nullable()
        .when(PaymentMethodsFormFields.PAYMENT_METHOD, {
            is: PaymentMethods.BANK_TRANSFER,
            then: (s) =>
                s
                    .matches(/^[A-Za-z0-9]{8}([A-Za-z0-9]{3})?$/, { message: 'Invalid BIC', excludeEmptyString: true })
                    .required('BIC is required'),
            otherwise: (s) => s.notRequired().nullable(),
        }),
});
